<template>
  <div class="chat-widget">
    <permission on="notification" />
    <div class="header flex items-center justify-between">
      <div class="fs14">
        {{ room.name }}
        <!-- <div>{{ room.url }}</div> -->
      </div>
      <div class="flex items-center align-center">
        <el-popover
          v-if="!isEmptyData(room)"
          placement="left"
          width="200"
          trigger="click"
          popper-class="chat-popover"
        >
          <div class="popover-menu">
            <ul>
              <li @click="exportMessages">
                <i class="far fa-comment" /> Export Messages
              </li>
              <li @click="refreshMessages">
                <i class="far fa-comment" /> Refresh Messages
              </li>
            </ul>
          </div>
          <el-button size="mini" class="el-icon-more micro" slot="reference">
          </el-button>
        </el-popover>
        <span>
          <el-button size="mini" class="micro" title="Unread">
            <i class="fas fa-comment-dots red" />{{ unreadMessages.length }}
          </el-button>
        </span>
        <span>
          <el-button size="mini" class="micro" title="Marked">
            <i class="fas fa-heart green" />{{ markedMessages.length }}
          </el-button>
        </span>
        <el-popover
          v-if="isAdmin && !isMarketplace"
          placement="bottom"
          width="300"
          trigger="click"
          popper-class="chat-popover"
        >
          <el-form v-model="space" size="mini" class="e-form">
            <el-form-item label="Space Name">
              <el-input v-model="space.name" />
            </el-form-item>
            <el-form-item label="Add 1 or more people">
              <el-select v-model="space.users" multiple class="full-width">
                <el-option
                  v-for="item in otherMembers"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="">
              <el-button
                type="primary"
                class="full-width"
                :disabled="invalidSpace"
                @click="saveSpace"
                >Create Space</el-button
              >
            </el-form-item>
          </el-form>
          <el-button
            size="mini"
            class="micro"
            plain
            slot="reference"
            @click="newSpace"
          >
            <i class="far fa-comment" />&nbsp;Start Space</el-button
          >
        </el-popover>
        <a
          v-if="isPopup"
          class="fas fa-xmark fs18 ml5"
          @click="$emit('toggleDialog', false)"
        />
      </div>
    </div>
    <div class="main">
      <Split :gutterSize="3">
        <SplitArea :size="area1.size - area2.size - area3.size">
          <div
            class="room-widget flex flex-col h-full"
            v-if="!isEmptyData(room)"
          >
            <div v-if="activeThread" class="thread-view-header">
              <button type="button" class="back-button" @click="closeThread">
                <i class="fas fa-arrow-left" />
              </button>
              <svg width="14" height="14" viewBox="0 -960 960 960">
                <path
                  d="M200-120q-33 0-56.5-23.5T120-200q0-36 20.5-65.5T195-308l85-32v-252q0-12-7-22.5T254-630l-59-22q-34-13-54.5-42.5T120-760q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760q0 36-20.5 65.5T765-652l-85 32v252q0 12 7 22.5t19 15.5l59 22q34 13 54.5 42.5T840-200q0 33-23.5 56.5T760-120zm400-255L223-233q-11 4-17 13t-6 20h560q0-11-6-20t-17-14l-59-22q-35-14-56.5-44T600-368zm160-385H200q0 11 6 20t17 13l59 22q35 14 56.5 44.5T360-592v7l377-142q11-4 17-13t6-20M360-500v130l240-90v-130zm120 20"
                />
              </svg>
              <div class="title" @click="openThreadView">
                {{ threadViewTitle }}
              </div>
            </div>
            <div class="messages">
              <infinite-loading
                direction="top"
                :identifier="room.uuid"
                @infinite="moreMessages"
              >
                <div slot="no-more">no more message</div>
                <div slot="no-results">no more message</div>
              </infinite-loading>
              <div
                v-for="(item, index) in displayItems"
                :key="index"
                class="message"
                v-observe-visibility="
                  item.msg.read
                    ? false
                    : (isVisible, entry) => readMessage(isVisible, entry, item)
                "
              >
                <slot v-if="item.type === 'threading'">
                  <div class="flex items-center gap-1">
                    <font class="name" :color="nameColor(item.msg.name)">
                      {{ item.msg.name }}
                    </font>
                    <span class="time">{{ viewTime(item.msg) }}</span>
                  </div>
                  <div
                    :class="[
                      'threading',
                      item.threading_type.toLowerCase(),
                      { unread: item.unread_count > 0 },
                    ]"
                    @click="selectThread(item)"
                  >
                    <div class="threading-title">
                      <div class="flex-1 flex items-center gap-1">
                        <svg width="14" height="14" viewBox="0 -960 960 960">
                          <path
                            d="M200-120q-33 0-56.5-23.5T120-200q0-36 20.5-65.5T195-308l85-32v-252q0-12-7-22.5T254-630l-59-22q-34-13-54.5-42.5T120-760q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760q0 36-20.5 65.5T765-652l-85 32v252q0 12 7 22.5t19 15.5l59 22q34 13 54.5 42.5T840-200q0 33-23.5 56.5T760-120zm400-255L223-233q-11 4-17 13t-6 20h560q0-11-6-20t-17-14l-59-22q-35-14-56.5-44T600-368zm160-385H200q0 11 6 20t17 13l59 22q35 14 56.5 44.5T360-592v7l377-142q11-4 17-13t6-20M360-500v130l240-90v-130zm120 20"
                          />
                        </svg>
                        <div class="w-80 truncate">
                          {{ threadTitle(item) }}
                        </div>
                      </div>
                      <div class="w-6 flex items-center gap-0.5">
                        <i
                          v-if="item.has_marked"
                          class="fas fa-heart fs11 green"
                        />
                        <div v-if="item.unread_count > 0">
                          <div class="el-badge__content is-dot" />
                        </div>
                      </div>
                    </div>
                    <div class="threading-content">
                      <div v-if="!isEmptyData((item.msg.text || '').trim())">
                        {{ item.msg.text }}
                      </div>
                      <div v-if="!isEmptyData(item.msg.sound)">
                        <i class="icons-sound" />
                        {{ item.msg?.sound?.duration }}"
                      </div>
                      <div v-if="!isEmptyData(item.msg.images)">
                        <i class="el-icon-picture-outline text-lg" />
                      </div>
                    </div>
                  </div>
                </slot>
                <slot v-else>
                  <slot v-if="item.msg.name == 'System'">
                    <div class="system">
                      <div class="time">{{ viewTime(item.msg) }}</div>
                      <p class="text">{{ item.msg.text }}</p>
                    </div>
                  </slot>
                  <slot v-else>
                    <div class="flex items-center justify-between">
                      <div class="flex items-center gap-1">
                        <font class="name" :color="nameColor(item.msg.name)">
                          {{ item.msg.name }}
                        </font>
                        <span class="time">{{ viewTime(item.msg) }}</span>
                      </div>
                      <div>
                        <a
                          v-if="markedMsg(item.msg)"
                          class="fas fa-heart fs11 green"
                          @click="markMessage(item.msg, false)"
                        />
                        <a
                          v-else
                          class="far fa-heart to-mark"
                          @click="markMessage(item.msg, true)"
                        />
                      </div>
                    </div>
                    <p
                      class="text"
                      v-if="!isEmptyData((item.msg.text || '').trim())"
                      v-html="tagifyHtml(item.msg.text)"
                      @click="clickText"
                    />
                    <div
                      class="sound"
                      v-if="!isEmptyData(item.msg.sound)"
                      :class="{
                        active: item.msg.sound.uuid == $store.chatSound.uuid,
                      }"
                      @click="playSound(item.msg.sound, item.msg)"
                    >
                      <i
                        class="icons-sound"
                        :class="[$store.chatSound.state]"
                      />
                      &nbsp;{{ item.msg.sound.duration }}"
                    </div>
                    <div
                      class="images-preview flex-start wrap"
                      v-if="!isEmptyData(item.msg.images)"
                    >
                      <div
                        class="image"
                        v-for="image in item.msg.images"
                        :key="image.uuid"
                      >
                        <el-image
                          v-if="image?.url?.thumb"
                          style="width: 125px; height: 125px"
                          :src="image.url.thumb"
                          fit="contain"
                          @click="previewImage(image)"
                        />
                      </div>
                    </div>
                  </slot>
                  <el-badge is-dot v-if="!item.msg.read" class="unread-dot" />
                </slot>
              </div>
              <div
                ref="bottom"
                class="bottom"
                v-observe-visibility="bottomMessage"
              />
              <div
                class="new-message"
                v-if="hasNewMessage"
                @click="scrollToRecent"
              >
                <i class="fas fa-chevron-down" />new message
              </div>
            </div>
            <div class="typists">
              <ul>
                <li v-for="(typist, index) in activeTypists" :key="index">
                  <span>{{ typist.name }} is typing <i class="typing" /></span>
                </li>
              </ul>
            </div>
            <div class="message-form">
              <slot v-if="audioWidget.open">
                <div class="flex items-center">
                  <el-button
                    size="mini"
                    icon="el-icon-close"
                    type="danger"
                    circle
                    plain
                    @click="toggleAudioWidget"
                  />
                  <div class="audio-widget">
                    <div class="col-span-1">
                      &nbsp;
                      <slot v-if="audioStates.duration > 0">
                        <slot v-if="!audioStates.playing">
                          <el-button type="primary" circle @click="startPlay">
                            <i class="fas fa-play" />
                          </el-button>
                        </slot>
                        <slot v-else>
                          <el-button type="primary" circle @click="stopPlay">
                            <i class="fas fa-stop" />
                          </el-button>
                        </slot>
                      </slot>
                    </div>
                    <div class="col-span-1">
                      <slot v-if="!audioStates.recording">
                        <el-button type="primary" circle @click="startRecord">
                          <i class="fas fa-microphone" />
                        </el-button>
                      </slot>
                      <slot v-else>
                        <el-tooltip
                          class="item"
                          effect="light"
                          :content="recorderDuration"
                          placement="top"
                          :manual="true"
                          v-model="audioStates.recording"
                        >
                          <el-button
                            class="recording"
                            type="primary"
                            circle
                            @click="stopRecord"
                          >
                            <i class="fas fa-microphone" />
                          </el-button>
                        </el-tooltip>
                      </slot>
                    </div>
                    <div class="col-span-1">
                      <slot
                        v-if="
                          audioStates.duration > 0 && !audioStates.recording
                        "
                      >
                        <el-button type="primary" circle @click="sendMessage">
                          <i class="fas fa-paper-plane" />
                        </el-button>
                      </slot>
                    </div>
                  </div>
                </div>
              </slot>
              <slot v-else>
                <div class="flex items-center justify-between">
                  <label
                    class="fas fa-microphone fs20 mr10 pointer"
                    @click="toggleAudioWidget"
                  />
                  <el-input
                    v-model="message.text"
                    type="textarea"
                    :autosize="{ minRows: 2 }"
                    @input="typingIndicator"
                    class="editor mr5"
                    @keydown.native="(event) => sendByEnter(event)"
                  />
                  <label class="fas fa-image fs20 mr10 pointer">
                    <input
                      type="file"
                      accept="image/*,application/pdf"
                      @change="chooseImage"
                      class="hidden"
                      multiple
                    />
                  </label>
                  <a
                    v-if="sendBtnReady"
                    class="fas fa-paper-plane fs20"
                    @click="sendMessage"
                  />
                  <a
                    v-else
                    class="fas fa-paper-plane fs20"
                    :disabled="!sendBtnReady"
                  />
                </div>
              </slot>
              <div
                class="images-preview images-preview--pending flex-start wrap"
              >
                <div
                  class="image"
                  v-for="(image, index) in images"
                  :key="index"
                  :class="{ uploading: image.uploading }"
                >
                  <div class="pending-attachment">
                    <div class="thumb-box">
                      <template v-if="image.isPdf">
                        <el-image
                          v-if="image.src"
                          style="width: 125px; height: 125px"
                          :src="image.src"
                          fit="contain"
                        />
                        <div v-else class="pdf-thumb-placeholder">
                          <i
                            v-if="image.pdfThumbLoading"
                            class="el-icon-loading fs24"
                          />
                          <i class="fas fa-file-pdf" />
                          <span v-if="image.pdfThumbLoading" class="pdf-hint"
                            >Preview…</span
                          >
                          <span
                            v-else-if="image.pdfThumbFailed"
                            class="pdf-hint"
                            >Preview unavailable</span
                          >
                        </div>
                      </template>
                      <el-image
                        v-else
                        style="width: 125px; height: 125px"
                        :src="image.src"
                        fit="contain"
                      />
                    </div>
                    <div
                      class="file-label"
                      :title="pendingAttachmentTitle(image)"
                    >
                      {{ pendingAttachmentLabel(image) }}
                    </div>
                  </div>
                  <i class="el-icon-loading fs20" />
                  <div class="top-right" v-if="!image.uploading">
                    <a v-if="image.uploaded" class="fas fa-check-circle" />
                    <a
                      v-else
                      class="fas fa-times-circle"
                      @click="removeImage(image)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <modal name="image-viewer" width="80%" height="100%">
            <div class="modal-wrapper">
              <div class="modal-header">
                {{ gallery.pdfSrc ? "PDF Viewer" : "Photo Views" }}
              </div>
              <div class="modal-content">
                <pdf-viewer
                  v-if="gallery.pdfSrc"
                  :src="gallery.pdfSrc"
                  height="calc(100vh - 50px)"
                />
                <e-viewer
                  v-else
                  :images="gallery.images"
                  :index="gallery.index"
                />
              </div>
            </div>
          </modal>
        </SplitArea>
        <SplitArea :size="area2.size" :minSize="area2.minSize">
          <div class="flex flex-col h-full">
            <el-collapse v-model="activeGroups" class="rooms">
              <el-collapse-item
                v-for="(spaces, group) in groups"
                :key="group"
                :name="group"
              >
                <template slot="title">
                  <div class="grow flex items-center gap-0.5 mr-0.5 font-sans">
                    <i class="far fa-comment fs15" />
                    <div class="grow flex items-center justify-between">
                      <div>{{ group }}</div>
                      <div class="text-2xs">{{ spaces.length }}</div>
                    </div>
                  </div>
                </template>
                <ul>
                  <li
                    v-for="room in spaces"
                    :key="room.uuid"
                    class="flex items-center justify-between"
                    :class="{ active: room.active }"
                    @click="selectRoom(room.uuid)"
                  >
                    <slot v-if="['chat', 'space'].includes(room.target)">
                      <el-popover
                        placement="left"
                        width="250"
                        trigger="hover"
                        :open-delay="750"
                      >
                        <div class="popover-menu">
                          <div class="name">{{ room.name }}</div>
                          <ul>
                            <slot v-if="room.target == 'space'">
                              <slot v-if="room.company_id == user.id">
                                <li>
                                  <el-popover
                                    placement="bottom"
                                    width="300"
                                    trigger="click"
                                  >
                                    <el-form
                                      size="mini"
                                      class="e-form"
                                      v-if="space.id == room.id"
                                    >
                                      <el-form-item label="Room Name">
                                        <el-input v-model="space.name" />
                                      </el-form-item>
                                      <el-form-item
                                        label="Add 1 or more people"
                                      >
                                        <el-select
                                          v-model="space.users"
                                          multiple
                                          class="full-width"
                                        >
                                          <el-option
                                            v-for="item in otherMembers"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id"
                                          >
                                          </el-option>
                                        </el-select>
                                      </el-form-item>
                                      <el-form-item label="">
                                        <div class="flex-start align-center">
                                          <el-button
                                            type="primary"
                                            :disabled="invalidSpace"
                                            @click="saveSpace(space)"
                                          >
                                            Save Space
                                          </el-button>
                                        </div>
                                      </el-form-item>
                                    </el-form>
                                    <div
                                      slot="reference"
                                      @click.stop="editSpace(room)"
                                      ><i class="fas fa-pen-to-square" /> Edit
                                      Space</div
                                    >
                                  </el-popover>
                                </li>
                                <li>
                                  <el-popconfirm
                                    title="Are you sure to delete this space?"
                                    confirmButtonText="Delete"
                                    cancelButtonText="Cancel"
                                    @confirm="deleteSpace(room)"
                                  >
                                    <div slot="reference"
                                      ><i class="fas fa-trash-can" /> Delete
                                      Space</div
                                    >
                                  </el-popconfirm>
                                </li>
                              </slot>
                              <slot v-else>
                                <li @click="leaveSpace(room)"
                                  ><i class="far fa-comment" /> Leave Space</li
                                >
                              </slot>
                            </slot>
                            <slot v-else>
                              <li>
                                <el-popconfirm
                                  title="Are you sure to delete this chat?"
                                  confirmButtonText="Delete"
                                  cancelButtonText="Cancel"
                                  @confirm="deleteChat(room)"
                                >
                                  <div slot="reference"
                                    ><i class="fas fa-trash-can" /> Delete
                                    Chat</div
                                  >
                                </el-popconfirm>
                              </li>
                            </slot>
                          </ul>
                        </div>
                        <el-avatar
                          slot="reference"
                          size="small"
                          :class="room.mobile"
                        >
                          {{ room.abbrev }}
                        </el-avatar>
                      </el-popover>
                    </slot>
                    <el-avatar v-else size="small" :class="room.mobile">
                      {{ room.abbrev }}
                    </el-avatar>
                    <div class="thumb">
                      <div class="name">{{ room.name }}</div>
                      <slot v-if="room.msg">
                        <div
                          v-if="room.msg.name != 'System'"
                          class="msg"
                          :class="{ bold: !room.msg.read }"
                        >
                          {{ room.msg.text }}
                        </div>
                      </slot>
                    </div>
                    <div class="flex items-center justify-between">
                      <div
                        class="fas fa-heart marked-icon"
                        v-if="hasMarked(room)"
                      />
                      <div
                        class="fas fa-comment-dots unread-icon"
                        v-if="hasUnread(room)"
                      />
                      <slot v-if="(stats = meetStats(room))">
                        <label
                          v-if="stats.joiners.length == 0"
                          class="fas fa-video icons-call"
                          :class="stats.call"
                          @click.stop="initMeet(room)"
                        />
                        <el-tooltip
                          v-else
                          class="item"
                          placement="left"
                          :content="stats.joiners.join(', ')"
                        >
                          <div class="meet-stats">
                            <label
                              class="fas fa-video icons-call"
                              :class="stats.call"
                              @click.stop="initMeet(room)"
                            />
                            <div class="num">{{ stats.joiners.length }}</div>
                          </div>
                        </el-tooltip>
                      </slot>
                    </div>
                  </li>
                </ul>
              </el-collapse-item>
            </el-collapse>
          </div>
        </SplitArea>
        <SplitArea :size="area3.size" v-if="!isMarketplace && isAdmin">
          <div class="members">
            <div
              class="member"
              v-for="member in otherMembers"
              :key="member.uuid"
            >
              <el-popover
                placement="left"
                width="250"
                trigger="hover"
                popper-class="chat-popover"
                :open-delay="750"
              >
                <div class="popover-menu">
                  <div class="name">{{ member.name }}</div>
                  <ul>
                    <li @click="startChat(member)">
                      <i class="far fa-comment" /> Start Chat
                    </li>
                  </ul>
                </div>
                <el-avatar
                  slot="reference"
                  size="small"
                  :class="{
                    [onlineStatus(member)]: true,
                    circled: member.circled,
                  }"
                >
                  {{ member.abbrev }}
                </el-avatar>
              </el-popover>
            </div>
          </div>
        </SplitArea>
        <AudioRecorder
          @setAudioResult="setAudioResult"
          ref="audioRecorder"
          :uuid="audioWidget.sound.uuid"
          :url="audioWidget.sound.url"
          :maxDuration="60000"
        />
        <ChatMeet ref="chatMeet" />
      </Split>
    </div>
  </div>
</template>
<script>
import { openDB } from "idb";
import { db } from "@/default/utils/firebase.js";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import {
  ref,
  child,
  query,
  push,
  update,
  set,
  get,
  onValue,
  onChildAdded,
  orderByChild,
  startAfter,
  endBefore,
  limitToLast,
} from "firebase/database";
import { getAuth, signInWithCustomToken } from "firebase/auth";
import { format } from "date-fns";
import AudioRecorder from "@/default/pages/chats/audio_recorder.vue";
import ChatMeet from "@/default/pages/chats/meet.vue";
import * as pdfjs from "https://cdn.jsdelivr.net/npm/pdfjs-dist@4.0.379/+esm";
const MSG_LIVE_DURATION = 3600 * 1000 * 24 * 90;
const MSG_AUTO_READ_DURATION = 3600 * 1000 * 24 * 7;
const PDFJS_CDN_BASE = "https://cdn.jsdelivr.net/npm/pdfjs-dist@4.0.379";
pdfjs.GlobalWorkerOptions.workerSrc = `${PDFJS_CDN_BASE}/build/pdf.worker.mjs`;
export default {
  name: "ChatWidget",
  components: {
    AudioRecorder,
    ChatMeet,
  },
  props: {
    user: {
      type: Object,
      default: () => ({}),
    },
    visible: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: String,
    },
  },
  data() {
    return {
      area1: {
        size: 100,
      },
      area2: {
        size: 30,
        minSize: 225,
      },
      area3: {
        size: 0,
      },
      env: null,
      idb: null,
      intervalId: null,
      activeThread: null,
      members: [],
      rooms: [],
      messages: [],
      threads: {},
      images: [],
      audioWidget: {
        open: false,
        recording: false,
        playing: false,
        sound: {},
      },
      message: { text: null, sending: false },
      gallery: { images: [], index: 0, pdfSrc: null },
      timestamp: new Date().getTime(),
      audioBlob: null,
      duration: null,
      typing: {
        timestamp: null,
        pushed: false,
      },
      notifiers: {},
      activeGroups: [],
      unreadMessages: [],
      markedMessages: [],
      markedKeys: [],
      space: {},
      flashTitles: {
        intervalId: null,
        index: 0,
        items: {
          default: document.title,
        },
      },
      format,
    };
  },
  async mounted() {
    if (!this.isMarketplace && this.isAdmin) this.area3.size = 4;
    await this.fetchChatEnv();
    await this.fetchChatMembers();
    await this.initIndexedDB();
    await this.authByToken();
    await this.registerFcm();
    await this.unreadBadge();

    this.intervalClock();
    this.intervalFlashTitle();
    this.computeMinArea();
    window.addEventListener("resize", this.computeMinArea);
    window.Chat = {
      loadRooms: this.loadRooms,
      initThread: this.initThread,
    };
    // move this meet widget to the end of body; the calendar using popup dialog which is hidden as default
    document.body.appendChild(document.querySelector(".chat-meet"));
    this.autoJoinMeet();
  },
  beforeDestroy() {
    window.clearInterval(this.intervalId);
    window.clearInterval(this.flashTitles.intervalId);
    window.removeEventListener("resize", this.computeMinArea);
  },
  watch: {
    async markedKeys(nv, ov) {
      if (JSON.stringify(nv) != JSON.stringify(ov)) {
        await this.markedBadge();
      }
    },
    displayItems: {
      handler(items) {
        (items || [])
          .filter((i) => i.type === "threading")
          .forEach(async (i) => await this.fetchThread(i));
      },
      immediate: true,
    },
  },
  computed: {
    isPopup() {
      return this.mode == "popup";
    },
    tenant() {
      return this.$store.tenant;
    },
    groups() {
      const groups = this._.groupBy(
        this._.orderBy(
          this.rooms,
          ["target_id", "asc"],
          ["group", "asc"],
          ["name", "asc"],
        ),
        "group",
      );
      this.activeGroups = Object.keys(groups).filter((o) => o != "Marketplace");
      return groups;
    },
    room() {
      return this.rooms.find((o) => o.active) || {};
    },
    nameColor() {
      return function (name) {
        return (
          this.members.find((o) => o.name == name) || { name_color: "#333" }
        ).name_color;
      };
    },
    onlineStatus() {
      return function (user) {
        const time = (this.$store.users[user.uuid] || {})["online"];
        if (!time) return "offline";
        const diff = this.timestamp - time;
        if (diff < 1000 * 30) return "online";
        if (diff < 1000 * 60 * 5) return "away";
        else return "offline";
      };
    },
    activeTypists() {
      return Object.values(this.room.typists).filter(
        (typist) => new Date().getTime() - typist.timestamp < 5000,
      );
    },
    meetStats() {
      return function (room) {
        var call = "none";
        var joiners = [];
        var { uuid, meet } = room;
        if (!meet) return { uuid, call, joiners };
        var roomId = Object.keys(meet)[0];
        var details = Object.values(meet)[0];
        if (new Date().getTime() - details.time > 1000 * 3600 * 6) {
          return { uuid, call, joiners };
        } else {
          joiners = Object.values(details)
            .filter((o) => o.status == "joined")
            .map((o) => o.name);
          if (joiners.length == 1) call = "single";
          if (joiners.length > 1) call = "multiple";
          return { uuid, room: roomId, call, joiners };
        }
      };
    },
    otherMembers() {
      return this.members.filter((o) => o.id != this.user.id);
    },
    invalidSpace() {
      return (
        this.isEmptyData(this.space.name) || this.isEmptyData(this.space.users)
      );
    },
    todayms() {
      return new Date().setHours(0, 0, 0, 0);
    },
    yesterdayms() {
      return this.todayms - 3600 * 1000 * 24;
    },
    viewTime() {
      return function (msg) {
        var seconds = (this.timestamp - msg.time) / 1000;
        var mins = parseInt(seconds / 60);
        if (mins < 1) return "now";
        if (mins < 60) return `${mins} min`;
        if (msg.time > this.todayms)
          return this.format(new Date(msg.time), "h:mm aa");
        if (msg.time > this.yesterdayms)
          return "yesterday " + this.format(new Date(msg.time), "h:mm aa");
        return this.format(new Date(msg.time), "EEE, LL/dd h:mm aa");
      };
    },
    hasUnread() {
      return function (room) {
        return this.unreadMessages.find((o) => o.uuid == room.uuid) != null;
      };
    },
    hasMarked() {
      return function (room) {
        return this.markedMessages.find((o) => o.uuid == room.uuid) != null;
      };
    },
    markedMsg() {
      return function (msg) {
        return this.markedKeys.includes(msg.key);
      };
    },
    sendBtnReady() {
      const text = (this.message.text || "").trim();
      return (
        !this.message.sending &&
        (!this.isEmptyData(text) || !this.isEmptyData(this.images))
      );
    },
    galleryImages() {
      let images = [];
      this.messages.forEach((o) =>
        (o.images || []).forEach((image) => {
          if (!image.url) return;
          const url =
            image.url.origin ||
            (image.url.thumb && image.url.thumb.replace("/thumb_", "/"));
          if (url && !this.looksLikePdfUrl(url)) images.push(url);
        }),
      );
      return images;
    },
    audioStates() {
      return this.$refs.audioRecorder.states || {};
    },
    recorderDuration() {
      return `${this.audioStates.dynamicDuration}"`;
    },
    hasNewMessage() {
      return !this.room.msg.read && !this.room.bottom;
    },
    threadViewTitle() {
      if (!this.activeThread) return "";
      return this.threadTitle(this.activeThread);
    },
    displayItems() {
      const list = this.messages; // already for current room

      if (this.activeThread) {
        // Thread view: only messages in this thread, sorted by time
        return this._.orderBy(
          list.filter(
            (m) =>
              m.threading === this.activeThread.threading &&
              m.threading_type === this.activeThread.threading_type,
          ),
          "time",
          "asc",
        ).map((msg) => ({ type: "message", msg }));
      }

      // Main view: general messages + one thread_summary per thread
      const groups = this._.groupBy(list, (m) => this.threadKey(m));
      const items = [];

      // General messages as single items
      (groups["__general__"] || []).forEach((msg) => {
        items.push({ type: "message", msg });
      });

      // One thread_summary per thread (use last message by time)
      Object.entries(groups).forEach(([key, msgs]) => {
        if (key === "__general__") return;
        const sorted = this._.orderBy(msgs, "time", "asc");
        const lastMessage = sorted[sorted.length - 1];
        items.push({
          type: "threading",
          threading: lastMessage.threading,
          threading_type: lastMessage.threading_type,
          unread_count: msgs.filter((o) => !o.read).length,
          has_marked: msgs.some((o) => this.markedKeys.includes(o.key)),
          msg: lastMessage,
        });
      });

      // Single sort by msg.time
      return this._.orderBy(items, "msg.time", "asc");
    },
  },
  methods: {
    threadKey(message) {
      const t = message.threading || "__general__";
      const type = message.threading_type ?? "__general__";
      return t === "__general__" ? "__general__" : `${t}|${type}`;
    },
    threadTitle(item) {
      const { threading_type, threading } = item;
      const key = `${threading_type}-${threading}`;
      return this.threads[key]?.title;
    },
    async fetchThread(item) {
      try {
        const { threading_type, threading } = item;
        const key = `${threading_type}-${threading}`;
        if (!this.threads[key]) {
          const { data } = await this.$http.post(`/api/v1/chat/thread`, {
            threading,
            threading_type,
          });
          this.$set(this.threads, key, data);
        }
        return this.threads[key];
      } catch (e) {}
    },
    setAudioResult(result) {
      this.audioBlob = result.blob;
      this.duration = result.duration;
    },
    intervalClock() {
      this.intervalId = window.setInterval(
        () => (this.timestamp = new Date().getTime()),
        15000,
      );
    },
    intervalFlashTitle() {
      this.flashTitles.intervalId = window.setInterval(() => {
        let titles = Object.values(this.flashTitles.items);
        let title = titles[this.flashTitles.index];
        if (title) document.title = titles[this.flashTitles.index];
        this.flashTitles.index = (this.flashTitles.index + 1) % titles.length;
      }, 1500);
    },
    initFlashTitle(room, msg) {
      if (msg.uid == this.user.uuid) return;
      let diff = new Date().getTime() - msg.time;
      if (diff < 10000) {
        switch (room.target) {
          case "chat":
            if (msg.name != "System") {
              this.flashTitles.items[room.uuid] = `${msg.name} messaged you`;
            }
            break;
          case "space":
            this.flashTitles.items[room.uuid] = `Space: ${room.name}`;
            break;
          case "trucker":
            this.flashTitles.items[room.uuid] = `${room.group}: ${room.name}`;
            break;
          case "customer":
            this.flashTitles.items[room.uuid] = `${room.name}`;
            break;
          default:
            break;
        }
      }
    },
    computeMinArea() {
      const widget = document.querySelector(".chat-widget");
      if (widget) {
        const width = widget.offsetWidth;
        if (width <= 650) this.area2.minSize = 200;
        this.area2.size = Math.ceil((this.area2.minSize / width) * 100.0);
      }
    },
    async authByToken(times = 1) {
      try {
        const {
          data: { token },
        } = await this.$http.get("/api/services/firebases/custom_token");
        await signInWithCustomToken(getAuth(), token);
        await this.markerListner();
        await this.roomListeners();
        return true;
      } catch (ex) {
        this.$message({
          message: "Failed to connect to chat service",
          type: "error",
        });
        setTimeout(async () => {
          this.$message({
            message: "Trying to connect to chat service",
            type: "success",
          });
          await this.authByToken(times + 1);
        }, 5000 * times);
        return false;
      }
    },
    async registerFcm() {
      try {
        if ("serviceWorker" in navigator) {
          await navigator.serviceWorker.register("/firebase-messaging-sw.js", {
            scope: "/",
          });
          const messaging = getMessaging();
          const vapidKey =
            "BFRE3liBEw7iHaSf7hANtUu8E_F6lsgvW00dzCr-FAeEPWJF5dSKNz-dqpvsVS6_cckt_g5isk098iPM0zSevhg";
          const token = await getToken(messaging, { vapidKey: vapidKey });
          await this.$http.post("/api/services/firebases/token", { token });
          onMessage(messaging, (payload) => {
            const { msga } = payload.data;
            if (msga == "call") this.incomingMeet(payload.data);
          });
        }
      } catch (ex) {
        console.log(ex);
      }
    },
    async fetchChatEnv() {
      try {
        this.env = (await this.$http.get("/api/v1/chat/env")).data;
      } catch (ex) {
        console.log(ex);
      }
    },
    async fetchChatMembers() {
      try {
        this.members = (await this.$http.get("/api/v1/chat/members")).data;
      } catch (ex) {
        console.log(ex);
      }
    },
    async initIndexedDB() {
      try {
        this.idb = await openDB(this.tenant, 1, {
          upgrade(db) {
            const store = db.createObjectStore("messages");
            store.createIndex("key", "key", { unique: true });
            store.createIndex("uuid", "uuid", { unique: false });
          },
        });
        await this.clearOldMessages();
      } catch (ex) {
        console.log(ex);
      }
    },
    async clearOldMessages() {
      try {
        const delTime = new Date().getTime() - MSG_LIVE_DURATION;
        const unreadTime = new Date().getTime() - MSG_AUTO_READ_DURATION;
        const ts = this.idb.transaction("messages", "readwrite");
        let cursor = await ts.objectStore("messages").openCursor();
        while (cursor) {
          const msg = cursor.value;
          if (msg.time < delTime) {
            await cursor.delete();
          } else {
            if (msg.time < unreadTime) {
              msg.read = true;
              await cursor.update(msg);
            }
          }
          await cursor.continue();
        }
      } catch (ex) {}
    },
    async unreadBadge() {
      try {
        const uuids = this.rooms.map((o) => o.uuid);
        this.unreadMessages = (await this.idb.getAll("messages")).filter(
          (o) => uuids.includes(o.uuid) && !o.read,
        );
        this.$emit("unreadBadge", this.unreadMessages.length);
      } catch (ex) {
        console.log(ex);
      }
    },
    async markedBadge() {
      try {
        this.markedMessages = (await this.idb.getAll("messages")).filter((o) =>
          this.markedKeys.includes(o.key),
        );
        this.$emit("markedBadge", this.markedMessages.length);
      } catch (ex) {
        console.log(ex);
      }
    },
    async loadRooms(data = {}) {
      try {
        if (data.widget == "visible" && !this.visible) return;
        const rooms = (await this.$http.get("/api/v1/chat/rooms")).data;
        const uuids = rooms.map((o) => o.uuid);
        this.rooms.forEach((o) => {
          if (!uuids.includes(o.uuid)) o.unsubscribe();
        });
        this.rooms = this.rooms.filter((o) => uuids.includes(o.uuid));
        for (const room of rooms) {
          let item = this.rooms.find((o) => o.uuid == room.uuid);
          if (item) {
            item.mobile = room.mobile;
            item.name = room.name;
            item.users = room.users;
          } else {
            if (room.uuid) {
              await this.roomListener(room);
              this.rooms.push(room);
            }
          }
        }
        await this.unreadBadge();
        await this.markedBadge();
        if (this.room) this.selectRoom(this.room.uuid);
      } catch (ex) {
        console.error(ex);
      }
    },
    newSpace() {
      this.space = {};
    },
    editSpace(room) {
      const ids = this.otherMembers.map((o) => o.id);
      this.space = { ...room };
      this.space.users = this.space.users.filter((id) => ids.includes(id));
    },
    async saveSpace() {
      try {
        const { message } = (
          await this.$http.post("/api/v1/chat/space", { room: this.space })
        ).data;
        this.space = {};
        this.$message({ message, type: "success" });
      } catch (ex) {
        console.log(ex);
      }
    },
    async leaveSpace(room) {
      try {
        const { message } = (
          await this.$http.post("/api/v1/chat/space", {
            room: { ...room, action: "leave" },
          })
        ).data;
        this.$message({ message, type: "success" });
        if (this.room.uuid == room.uuid) this.unselectRoom();
      } catch (ex) {
        console.log(ex);
      }
    },
    async deleteSpace(room) {
      try {
        const { message } = (
          await this.$http.post("/api/v1/chat/space", {
            room: { ...room, action: "delete" },
          })
        ).data;
        this.$message({ message, type: "success" });
        if (this.room.uuid == room.uuid) this.unselectRoom();
      } catch (ex) {
        console.log(ex);
      }
    },
    async startChat(member) {
      try {
        const users = [member.id, this.user.id];
        const room = (
          await this.$http.post("/api/v1/chat/chat", { room: { users } })
        ).data;
        setTimeout(() => {
          this.selectRoom(room.uuid);
        }, 1500);
      } catch (ex) {
        console.log(ex);
      }
    },
    async deleteChat(room) {
      try {
        const { message } = (
          await this.$http.post("/api/v1/chat/chat", {
            room: { ...room, action: "delete" },
          })
        ).data;
        this.$message({ message, type: "success" });
        if (this.room.uuid == room.uuid) this.unselectRoom();
      } catch (ex) {
        console.log(ex);
      }
    },
    async markerListner() {
      try {
        const uuid = this.user.uuid;
        const path = `${this.env}/${this.tenant}/markers/${uuid}`;
        const markersRef = query(ref(db, path));
        onValue(markersRef, async (snapshot) => {
          this.markedKeys = [];
          snapshot.forEach((data) => {
            this.markedKeys.push(data.key);
          });
        });
      } catch (ex) {
        console.error(ex);
      }
    },
    async roomListeners() {
      try {
        const rooms = (await this.$http.get("/api/v1/chat/rooms")).data;
        this.rooms = (
          await Promise.all(
            rooms.filter((o) => o.uuid).map((room) => this.roomListener(room)),
          )
        ).filter((ex) => ex);
        await this.unreadBadge();
        await this.markedBadge();
      } catch (ex) {
        console.error(ex);
      }
    },
    async roomListener(room) {
      try {
        const msgs = await this.roomMessages(room);
        room.msg = msgs[msgs.length - 1] || {
          time: new Date().getTime() - MSG_LIVE_DURATION,
          read: true,
        };
        const typistsRef = ref(db, `${room.url}/typists`);
        this.$set(room, "typists", {});
        onValue(typistsRef, async (snapshot) => {
          const typists = snapshot.val() || {};
          delete typists[this.user.uuid];
          this.$set(room, "typists", typists);
        });

        const meetRef = ref(db, `${room.url}/meet`);
        onValue(meetRef, async (snapshot) => {
          this.$set(room, "meet", snapshot.val());
        });
        const roomRef = query(
          ref(db, `${room.url}/messages`),
          startAfter(room.msg.time),
          orderByChild("time"),
          limitToLast(20),
        );
        room.unsubscribe = onChildAdded(roomRef, async (data) => {
          const rawMsg = data.val();
          // Use active flags on this.rooms (same as selection), not only the room computed, so "current room" is reliable in async Firebase callbacks.
          const onRoom = this.rooms.some(
            (o) => o.active && o.uuid == room.uuid,
          );
          const read = onRoom && this.room.bottom;
          const msg = Object.assign({}, rawMsg, {
            uuid: room.uuid,
            key: data.key,
            read,
          });
          this.autoReadMessage(msg);
          this.$set(room, "msg", msg);
          let notifyText;
          if (onRoom) {
            this.$set(this.room, "bottomLocked", this.room.bottom);
            this.messages.push(msg);
            if (this.room.bottom || msg.uid == this.user.uuid)
              this.scrollToRecent();
          } else {
            let diff = new Date().getTime() - msg.time;
            if (diff < 10000) {
              notifyText = msg.text;
              if (!this.isEmptyData(msg.sound))
                notifyText = "New Voice Message";
              if (!this.isEmptyData(msg.images)) notifyText = "New Image";
            }
            this.initFlashTitle(room, msg);
          }

          await this.idb.put("messages", msg, msg.key);
          if (!msg.read) await this.unreadBadge();
          if (notifyText && msg.uid != this.user.uuid) {
            window.SimpleNotify({
              title: msg.name,
              message: notifyText.substr(0, 100),
            });
          }
        });
        return room;
      } catch (ex) {
        console.log(ex);
        console.error(ex);
      }
    },
    async roomMessages(room) {
      try {
        return this._.sortBy(
          await this.idb.getAllFromIndex("messages", "uuid", room.uuid),
          "time",
        );
      } catch (ex) {
        console.error(ex);
      }
    },
    selectRoom(uuid) {
      let room = this.rooms.find((o) => o.uuid == uuid);
      if (room) {
        if (this.room.uuid != uuid) {
          this.activeThread = null;
          this.messages = [];
          this.rooms.map((o) => this.$set(o, "active", o == room));
          this.members.forEach((o) => (o.circled = room.users.includes(o.id)));
          delete this.flashTitles.items[room.uuid];
          setTimeout(() => this.editorListener(), 500);
        }
      }
    },
    unselectRoom() {
      this.messages = [];
      this.rooms.map((o) => this.$set(o, "active", false));
      this.members.forEach((o) => this.$set(o, "circled", false));
    },
    async initThread(target) {
      window.ChatPopup.toggle(true);
      const room = this.rooms.find((o) => target.rooms.includes(o.uuid));
      if (room) {
        this.selectRoom(room.uuid);
        await this.selectThread(target);
      } else {
        this.$msgbox({
          title: "Warning",
          message: "The chat room is not available. Contact support for help.",
          showClose: false,
        });
      }
    },
    async selectThread(item) {
      if (item.type !== "threading") return;
      this.activeThread = {
        threading: item.threading,
        threading_type: item.threading_type,
      };
      await this.fetchThread(this.activeThread);
      this.openThreadView();
    },
    closeThread() {
      this.activeThread = null;
      this.scrollToRecent();
      Dialog.close();
    },
    bottomMessage(isVisible, entry) {
      if (this.room.bottomLocked) return;
      this.$set(this.room, "bottom", isVisible);
    },
    async moreMessages($state) {
      try {
        const { uuid, url } = this.room;
        const first = this.messages[0];
        if (first) {
          const roomRef = query(
            ref(db, `${url}/messages`),
            endBefore(first.time),
            orderByChild("time"),
            limitToLast(20),
          );

          onValue(roomRef, async (snapshot) => {
            const records = [];
            snapshot.forEach((data) => {
              records.push(
                Object.assign({}, data.val(), { uuid, key: data.key }),
              );
            });
            for (const msg of records) {
              this.autoReadMessage(msg);
              await this.idb.put("messages", msg, msg.key);
            }
            this.messages = await this.roomMessages(this.room);
            if (records.length == 20) {
              $state.loaded();
            } else {
              $state.complete();
            }
          });
        } else {
          this.messages = await this.roomMessages(this.room);
          if (this.messages.length == 0) {
            $state.complete();
          } else {
            $state.loaded();
          }
        }
      } catch (ex) {
        console.error(ex);
      }
    },
    async sendByEnter(e) {
      if (e.shiftKey || e.ctrlKey || e.altKey || e.metaKey) return;
      if (e.keyCode == 13 && this.sendBtnReady) await this.sendMessage();
    },
    async sendMessage() {
      try {
        this.message.sending = true;
        await this.uploadImages();
        const images = this.images.filter((o) => o.uploaded);
        const path = `${this.room.url}/messages`;
        const msgKey = push(child(ref(db), path)).key;
        const message = {
          name: this.user.name,
          uid: this.user.uuid,
          text: this.message.text,
          time: new Date().getTime(),
        };
        if (this.activeThread) {
          message.threading = this.activeThread.threading;
          message.threading_type = this.activeThread.threading_type;
        }
        if (images.length > 0)
          message.images = images.map((o) => {
            return { uuid: o.uuid, url: o.url };
          });

        if (this.audioBlob) {
          message.sound = await this.uploadAudioMessage();
          this.duration = null;
        }
        const updates = {};
        updates[`${path}/${msgKey}`] = message;
        update(ref(db), updates);

        const { name, uuid, group, mobile } = this.room;
        Object.assign(message, { room: { name, uuid, group, mobile } });
        await this.notify(message);

        this.images = [];
        this.message = { text: null, sending: false };
        if (message.sound) this.$refs.audioRecorder.reset();
      } catch (ex) {
        this.message.sending = false;
        console.log(ex);
      }
    },
    typingIndicator() {
      this.typing.name = this.user.name;
      this.typing.timestamp = new Date().getTime();
      if (!this.typing.pushed) {
        this.typing.pushed = true;
        const path = `${this.room.url}/typists/${this.user.uuid}`;
        const { name, timestamp } = this.typing;
        set(ref(db, path), { name, timestamp });
      }
      if (this.typing.timeoutId) clearTimeout(this.typing.timeoutId);
      this.typing.timeoutId = setTimeout(() => {
        const still = new Date().getTime() - this.typing.timestamp;
        if (still >= 2500) {
          this.typing.pushed = false;
          const path = `${this.room.url}/typists/${this.user.uuid}`;
          set(ref(db, path), null);
        }
      }, 3000);
    },
    async notify(message) {
      try {
        if (["ready", "resumed"].includes(message.room.mobile)) return;
        await this.$http.post("/api/v1/chat/notify", { message });
      } catch (ex) {
        console.log(ex);
      }
    },
    autoReadMessage(msg) {
      msg.read =
        msg.name == "System" ||
        msg.uid == this.user.uuid ||
        msg.time < new Date().getTime() - 3600 * 1000 * 24 * 7;
    },
    readMessage(isVisible, entry, item) {
      if (item.type === "threading") return;
      const msg = item.msg;
      if (isVisible && !msg.read) {
        if (!this.isEmptyData(msg.sound)) return;
        setTimeout(async () => await this.markReadMessage(msg), 1500);
      }
    },
    async markReadMessage(msg) {
      try {
        msg.read = true;
        const index = this.messages.findIndex((o) => o.key == msg.key);
        this.messages.splice(index, 1, msg);
        if (this.room.msg.key == msg.key) this.room.msg.read = true;
        await this.idb.put("messages", msg, msg.key);
        await this.unreadBadge();
      } catch (ex) {
        console.error(ex);
      }
    },
    async markMessage(msg, marked) {
      try {
        msg.marked = marked;
        const uuid = this.user.uuid;
        const path = `${this.env}/${this.tenant}/markers/${uuid}`;
        if (marked) {
          update(ref(db, path), { [msg.key]: true });
        } else {
          update(ref(db, path), { [msg.key]: null });
        }
      } catch (ex) {
        console.error(ex);
      }
    },
    scrollToRecent() {
      setTimeout(() => {
        if (!this.$refs.bottom) return;
        this.$refs.bottom.scrollIntoView({ behavor: "smooth" });
        this.$set(this.room, "bottomLocked", false);
      }, 250);
    },
    editorListener() {
      document
        .querySelector(".message-form .editor textarea")
        .addEventListener("paste", this.pasteImage);
    },
    looksLikePdfUrl(url) {
      return (url || "").toLowerCase().split("?")[0].endsWith(".pdf");
    },
    pendingAttachmentTitle(image) {
      const name = image.file && image.file.name;
      if (name) return name;
      return image.isPdf ? "PDF" : "Image";
    },
    pendingAttachmentLabel(image) {
      const name = image.file && image.file.name;
      if (!name) return image.isPdf ? "PDF document" : "Image";
      const max = 36;
      return name.length > max ? `${name.slice(0, max - 1)}…` : name;
    },
    async renderPdfFirstPageDataUrl(file) {
      const data = await file.arrayBuffer();
      const pdf = await pdfjs.getDocument({ data }).promise;
      const page = await pdf.getPage(1);
      const baseViewport = page.getViewport({ scale: 1 });
      const scale = Math.min(
        125 / baseViewport.width,
        125 / baseViewport.height,
      );
      const viewport = page.getViewport({ scale });
      const canvas = document.createElement("canvas");
      canvas.width = viewport.width;
      canvas.height = viewport.height;
      await page.render({
        canvasContext: canvas.getContext("2d"),
        viewport,
      }).promise;
      return canvas.toDataURL("image/jpeg", 0.88);
    },
    readImage(file) {
      if (!file || !(file instanceof Blob)) return;
      const isPdf =
        file.type === "application/pdf" ||
        (file.name && file.name.toLowerCase().endsWith(".pdf"));
      if (isPdf) {
        const entry = {
          file,
          src: null,
          isPdf: true,
          pdfThumbLoading: true,
          pdfThumbFailed: false,
        };
        this.images.push(entry);
        this.renderPdfFirstPageDataUrl(file)
          .then((src) => {
            this.$set(entry, "src", src);
            this.$set(entry, "pdfThumbLoading", false);
          })
          .catch(() => {
            this.$set(entry, "pdfThumbLoading", false);
            this.$set(entry, "pdfThumbFailed", true);
          });
        return;
      }
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.images.push({ file, src: reader.result });
      };
    },
    chooseImage(event) {
      const { files } = event.target;
      if (!files) return;
      Array.from(files).forEach((file) => this.readImage(file));
      event.target.value = "";
    },
    pasteImage(event) {
      const data = event.clipboardData || window.clipboardData;
      if (!data || !data.items) return;
      for (let i = 0; i < data.items.length; i += 1) {
        const item = data.items[i];
        if (item.kind === "file" && item.type.startsWith("image/")) {
          const file = item.getAsFile();
          if (file) {
            this.readImage(file);
            event.preventDefault();
            return;
          }
        }
      }
    },
    removeImage(image) {
      let index = this.images.findIndex((o) => o == image);
      if (index >= 0) this.images.splice(index, 1);
    },
    previewImage(image) {
      const origin = image.url && image.url.origin;
      if (origin && this.looksLikePdfUrl(origin)) {
        this.gallery = { images: [], index: 0, pdfSrc: origin };
        this.$modal.show("image-viewer");
        return;
      }
      const images = this.galleryImages;
      const index = images.findIndex((url) => image.url.origin == url);
      this.gallery = { images, index, pdfSrc: null };
      this.$modal.show("image-viewer");
    },
    async uploadImages() {
      try {
        for (const image of this.images) {
          image.uploading = true;
          const result = (
            await this.$http.uploadPost(
              "/api/v1/chat/image",
              "file",
              image.file,
            )
          ).data;
          image.uploaded = true;
          image.uploading = false;
          image.uuid = result.uuid;
          image.url = { origin: result.url, thumb: result.thumb_url };
        }
      } catch (ex) {
        console.log(ex);
      }
    },
    async uploadAudioMessage() {
      try {
        const ext = this.audioBlob.type.split(";")[0].split("/").pop();
        const myFile = new File([this.audioBlob], `sound.${ext}`, {
          type: this.audioBlob.type,
        });
        const { data } = await this.$http.uploadPost(
          "/api/v1/chat/sound",
          "file",
          myFile,
          { duration: this.duration },
        );
        this.audioBlob = null;
        return {
          duration: data.data.duration,
          url: data.url,
          uuid: data.uuid,
        };
      } catch (ex) {
        console.error(ex);
      }
    },
    tagifyHtml(text) {
      if (text) {
        return text.replaceAll(
          /([a-zA-Z]{4}\d{6,7})/gi,
          "<a class='number'>$1</a>",
        );
      }
    },
    clickText(evt) {
      const elem = evt.target;
      if (elem.classList.contains("number")) {
        QuickSearch.autoFill(elem.innerText);
      }
    },
    async openThreadView() {
      Dialog.close();
      switch (this.activeThread.threading_type) {
        case "Container":
          await this.openContainer();
          break;
        case "SpotQuote":
          await this.openQuote();
          break;
        default:
          break;
      }
    },
    async openContainer() {
      try {
        const thread = await this.fetchThread(this.activeThread);
        Dialog.open({
          width: "900px",
          pivotX: 0.4,
          title: "Container: " + thread.title,
          url: "/containers/" + thread.id,
        });
      } catch (ex) {
        this.$message({
          message:
            ex?.response?.data?.errors ||
            ex?.message ||
            "Open container failed",
          type: "error",
        });
      }
    },
    async openQuote() {
      try {
        const quote = (
          await this.$http.get(
            `/api/broker/spot_quotes/${this.activeThread.threading}`,
          )
        ).data;
        Dialog.open({
          componentPath: "pages/carriers/quote",
          pivotX: 0.4,
          pivotY: 0.5,
          width: "500px",
          height: "auto",
          uuid: quote.uuid,
          carrier: {
            ...quote.tenant,
            url: quote.carrier_url,
          },
        });
      } catch (ex) {
        this.$message({
          message:
            ex?.response?.data?.errors || ex?.message || "Open quote failed",
          type: "error",
        });
      }
    },
    toggleAudioWidget() {
      this.audioWidget.open = !this.audioWidget.open;
      this.$refs.audioRecorder.reset();
    },
    startRecord() {
      this.$refs.audioRecorder.startRecording();
    },
    stopRecord() {
      this.$refs.audioRecorder.stopRecording();
    },
    startPlay() {
      this.$refs.audioRecorder.startPlaying();
    },
    stopPlay() {
      this.$refs.audioRecorder.stopPlaying();
    },
    async playSound(sound, msg) {
      this.audioWidget.open = false;
      if (this.audioWidget.sound.uuid == sound.uuid) {
        if (this.audioStates.playing) {
          this.stopPlay();
          this.audioWidget.sound = {};
        } else {
          this.startPlay();
        }
      } else {
        this.audioWidget.sound = sound;
      }
      if (msg) await this.markReadMessage(msg);
    },
    initMeet(room) {
      const { name } = this.$store.chatMeet;
      if (name != null) {
        this.$msgbox({
          title: "Active Meeting",
          message: `You already have a meeting room with ${name}.`,
          showClose: false,
        });
      } else {
        const stats = this.meetStats(room);
        if (stats.call == "none") {
          this.$confirm(
            `Are you sure to call ${room.name}?`,
            "Video Meeting",
          ).then(async () => {
            const { data } = await this.$http.post("/api/v1/chat/meet", {
              uuid: stats.uuid,
              status: "init",
            });
            this.joinMeet(data);
          });
        } else {
          this.$confirm(
            `Are you sure to join the call to ${room.name}?`,
            "Video Meeting",
          ).then(async () => {
            this.joinMeet(stats);
          });
        }
      }
    },
    incomingMeet(data) {
      const { room, caller, uuid } = data;
      if (this.notifiers[room] == null) {
        const h = this.$createElement;
        this.playSound({ url: "/ring.m4a", uuid });
        const self = this;
        this.notifiers[room] = this.$notify({
          title: "Video Meeting",
          position: "bottom-left",
          customClass: "dense incoming-meet",
          duration: 30000,
          dangerouslyUseHTMLString: true,
          message: h("div", { class: "flex items-center justify-between" }, [
            h("div", {}, `Incoming call from ${caller}...`),
            h("a", {
              class: "accept fa-solid fa-phone",
              on: { click: this.joinMeet.bind(this, data) },
            }),
          ]),
          onClose() {
            self.notifiers[room] = null;
            self.stopPlay();
          },
        });
      }
    },
    autoJoinMeet() {
      const uri = window.location.search.substring(1);
      const params = new URLSearchParams(uri);
      const room = params.get("room");
      const uuid = params.get("uuid");
      const time = params.get("time");
      if (room && uuid && time) {
        const duration = new Date().getTime() - parseInt(time);
        if (duration <= 60 * 1000) {
          const { name } = this.$store.chatMeet;
          if (name != null) {
            this.$msgbox({
              title: "Active Meeting",
              message: `You already have a meeting room with ${name}.`,
              showClose: false,
            });
          } else {
            this.joinMeet({ uuid, room });
          }
        }
      }
    },
    joinMeet(data) {
      const { name } = this.$store.chatMeet;
      if (name != null) {
        this.$msgbox({
          title: "Active Meeting",
          message: `You already have a meeting room with ${name}.`,
          showClose: false,
        });
      } else {
        const { uuid, room } = data;
        const notifier = this.notifiers[room];
        if (notifier) notifier.close();
        const options = {
          roomName: room,
          noSSL: false,
          userInfo: {
            displayName: this.user.name,
          },
          configOverwrite: {
            disableInviteFunctions: true,
            startWithAudioMuted: false,
            enableNoisyMicDetection: true,
            toolbarButtons: [
              "camera",
              "closedcaptions",
              "desktop",
              "download",
              "fullscreen",
              "hangup",
              "highlight",
              "livestreaming",
              "microphone",
              "noisesuppression",
              "participants-pane",
              "raisehand",
              "recording",
              "select-background",
              "tileview",
              "toggle-camera",
              "videoquality",
            ],
            apiLogLevels: ["error"],
          },
        };
        const url = "/api/v1/chat/meet";
        const params = { uuid, room };
        this.$refs.chatMeet.embedJitsiWidget(options, {
          title: () => {
            return this.rooms.find((o) => o.uuid == uuid).name;
          },
          inited: async () => {
            await this.$http.post(url, { ...params, status: "invited" });
          },
          joined: async () => {
            this.meetStatus({ ...params, status: "joined" });
            await this.$http.post(url, { ...params, status: "joined" });
          },
          left: async () => {
            this.meetStatus({ ...params, status: "left" });
            await this.$http.post(url, { ...params, status: "left" });
          },
        });
      }
    },
    meetStatus(details) {
      const { uuid, room, status } = details;
      const path = `${this.env}/${this.tenant}/rooms/${uuid}/meet/${room}/${this.user.uuid}`;
      set(ref(db, path), { name: this.user.name, status });
    },
    async deleteMessages() {
      const { uuid } = this.room;
      if (!uuid || !this.idb) return;
      const keys = await this.idb.getAllKeysFromIndex("messages", "uuid", uuid);
      await Promise.all(keys.map((key) => this.idb.delete("messages", key)));
    },
    async exportMessages() {
      try {
        if (!this.room.uuid || !this.idb) return;
        const messages = this._.sortBy(
          await this.idb.getAllFromIndex("messages", "uuid", this.room.uuid),
          "time",
        );
        const blob = new Blob([JSON.stringify(messages, null, 2)], {
          type: "application/json",
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `${this.room.name || this.room.uuid}.json`;
        link.click();
        window.URL.revokeObjectURL(link.href);
      } catch (ex) {
        console.error(ex);
      }
    },
    async refreshMessages() {
      try {
        if (!this.room.uuid || !this.idb || !this.room.url) return;
        await this.deleteMessages();

        const { uuid, url } = this.room;
        const roomRef = query(
          ref(db, `${url}/messages`),
          orderByChild("time"),
          limitToLast(20),
        );
        const snapshot = await get(roomRef);
        const records = [];
        snapshot.forEach((data) => {
          records.push(
            Object.assign({}, data.val(), { uuid, key: data.key, read: true }),
          );
        });
        for (const msg of records) {
          await this.idb.put("messages", msg, msg.key);
        }
        if (records.length) {
          const room = this.rooms.find((o) => o.uuid == uuid);
          if (room) this.$set(room, "msg", records[records.length - 1]);
        }

        this.unselectRoom();
        this.selectRoom(uuid);
        this.scrollToRecent();
        await this.unreadBadge();
      } catch (ex) {
        console.error(ex);
      }
    },
  },
};
</script>
<style lang="scss">
.chat-widget {
  @apply bg-white h-full;

  .header {
    @apply h-9 p-1 border-b border-gray-300 bg-slate-100;
  }
}

.room-widget {
  @apply p-2;

  .thread-view-header {
    @apply relative text-center text-xs bg-sky-100 -m-2 p-1 z-50 flex items-center justify-center gap-1;
    .back-button {
      @apply absolute left-1 top-1/2 -translate-y-1/2;
    }
    .title {
      @apply cursor-pointer hover:underline hover:text-blue-600 max-w-80 truncate;
    }
  }

  .messages {
    @apply relative flex-1 overflow-y-auto h-0;

    .bottom {
      @apply border-t border-transparent;
    }

    .new-message {
      @apply sticky bottom-0 left-1/2 -translate-x-1/2 w-28 bg-sky-500 text-white py-0.5 px-1 text-xs rounded-xl text-center cursor-pointer;
    }

    &:empty::after {
      content: "No Message";
    }

    .message {
      @apply p-0.5 relative;

      .unread-dot {
        @apply absolute top-1/2 right-2;
      }

      .system {
        @apply text-center w-80 mx-auto p-1 border border-gray-300 rounded-md bg-slate-50;
      }

      .threading {
        @apply border rounded w-96 text-xs cursor-pointer my-1;
        &.container {
          .threading-title {
            @apply bg-green-100;
          }
        }
        &.spotquote {
          .threading-title {
            @apply bg-sky-100;
          }
        }
        &.unread {
          @apply border-red-300;
        }
        .threading-title {
          @apply p-1 border rounded-t flex items-center justify-between;
        }
        .threading-content {
          @apply truncate min-w-0 p-1;
        }
      }

      .name {
        @apply text-xs font-bold;
      }

      .time {
        @apply text-2xs font-semibold text-gray-500;
      }

      .to-mark {
        @apply text-xs invisible;
      }

      &:hover {
        .to-mark {
          @apply visible;
        }
      }

      p.text {
        @apply p-1 -mx-1 w-full text-xs leading-4 box-border whitespace-pre-wrap break-words;
        .number {
          @apply underline text-blue-500 font-bold cursor-pointer;
        }
      }

      .sound {
        @apply border border-gray-300 rounded-md p-0.5 h-6 w-48 text-xs cursor-pointer;

        &.active {
          @apply border-blue-400 bg-sky-50;

          .icons-sound.playing {
            @apply text-red-500;
            animation: tilt-shaking 0.25s linear infinite;
          }
        }
      }

      &:hover {
        p {
          @apply bg-slate-100 rounded-md;
        }
      }
    }
  }

  .typists {
    @apply text-xs italic text-gray-500 h-3;
    li {
      @apply inline-block mr-1;
    }
  }

  .images-preview {
    @apply mt-1 bg-white;

    &.images-preview--pending {
      .pending-attachment {
        @apply flex flex-col items-stretch max-w-[125px];
      }

      .file-label {
        @apply mt-0.5 text-2xs text-gray-600 leading-tight max-w-[125px] truncate tracking-tighter;
      }
    }

    .image {
      @apply m-0.5 relative;

      .thumb-box {
        @apply w-[125px] h-[125px] border border-gray-200 rounded bg-white;
      }

      .pdf-thumb-placeholder {
        @apply w-[125px] h-[125px] flex flex-col items-center justify-center gap-0.5 text-red-600 bg-gray-50 rounded px-1;

        .fa-file-pdf {
          @apply text-3xl;
        }

        .pdf-hint {
          @apply text-2xs text-gray-500 text-center leading-tight;
        }
      }

      &.uploading {
        .el-image {
          @apply opacity-25;
        }

        .el-icon-loading {
          @apply block;
        }

        .top-right {
          @apply hidden;
        }
      }

      .el-icon-loading {
        @apply hidden absolute top-1/2 right-1/2 -translate-x-1/2 -translate-y-1/2;
      }

      .top-right {
        @apply absolute -top-1 -right-1;

        .fa-check-circle {
          @apply text-green-500 #{!important};
        }

        .fa-times-circle {
          @apply text-gray-500 #{!important};
        }
      }

      &:hover {
        .fa-times-circle {
          @apply block;
        }
      }
    }

    &:empty {
      @apply hidden;
    }
  }

  .message-form {
    @apply bg-slate-100 -m-2 mt-1 p-2 border-t border-gray-300;

    .audio-widget {
      @apply grow grid grid-cols-3 gap-1 text-center;

      .el-button {
        @apply w-[54px] h-[54px];

        i {
          @apply text-2xl #{!important};
        }
      }

      .recording {
        @apply border-red-500 bg-red-500 text-white;

        .fa-microphone {
          animation: tilt-shaking 0.15s linear infinite !important;
        }
      }
    }
  }
}

.members {
  @apply bg-white py-1;

  .member {
    @apply m-0.5;

    .el-avatar {
      @apply w-6 h-6 border-2 border-gray-300 text-2xs leading-5 font-bold bg-gray-400 cursor-pointer;

      &.online {
        @apply bg-green-500;
      }

      &.away {
        @apply bg-orange-500;
      }

      &.circled {
        @apply border-red-500;
      }
    }
  }
}

.el-collapse.rooms {
  .el-collapse-item__header {
    @apply text-xs bg-sky-50 p-1 h-8 border-b border-gray-300;
  }

  .el-collapse-item__content {
    @apply p-0.5 leading-3;

    ul {
      li {
        @apply py-0.5 text-xs items-center;

        .fas {
          @apply text-sm #{!important};
        }

        &:hover {
          @apply bg-slate-100 cursor-pointer;
        }

        &.active {
          @apply bg-blue-50;
        }

        .el-avatar {
          @apply mx-1 flex-shrink-0 text-2xs font-bold;
          &.el-avatar--small {
            @apply w-6 h-6 leading-6 bg-gray-400;
          }

          &.online,
          &.ready,
          &.resumed {
            @apply bg-green-500;
          }
        }

        .thumb {
          @apply flex-1 overflow-hidden;

          .name {
            @apply text-ellipsis block overflow-hidden whitespace-nowrap;
          }

          .msg {
            @apply text-2xs italic text-ellipsis block overflow-hidden whitespace-nowrap;
          }
        }

        .marked-icon {
          @apply text-xs text-green-500;
        }

        .unread-icon {
          @apply text-xs text-red-500;
        }

        .icons-call {
          @apply text-lg text-gray-500 mr-2.5 cursor-pointer;

          &.single {
            @apply text-red-500;
            animation: tilt-shaking 0.25s linear infinite;
          }

          &.multiple {
            @apply text-green-500;
          }
        }

        .meet-stats {
          @apply relative;

          .num {
            @apply absolute top-0.5 left-1 text-2xs font-bold text-white;
          }
        }
      }
    }
  }
}

.popover-menu {
  .name {
    @apply border-b border-gray-300 -m-1 p-1 bg-sky-50;
  }

  ul {
    @apply -m-1 p-2;

    li {
      @apply py-1 px-0.5 rounded cursor-pointer;

      &:hover {
        @apply bg-slate-100;
      }
    }
  }
}

.typing::after {
  @apply inline-block;
  animation: dotty steps(1, end) 1s infinite;
  content: "";
}

.incoming-meet {
  @apply w-96;

  .el-notification__group {
    @apply w-11/12;
  }

  .accept {
    @apply bg-green-500 text-white rounded-md text-sm leading-7 w-7 h-7 text-center;
    animation: tilt-shaking 0.25s linear infinite;
  }
}

.chat-popover {
  @apply z-[5001] #{!important};
}

@keyframes tilt-shaking {
  0% {
    transform: rotate(0deg);
  }

  25% {
    transform: rotate(10deg);
  }

  50% {
    transform: rotate(0eg);
  }

  75% {
    transform: rotate(-10deg);
  }

  100% {
    transform: rotate(0deg);
  }
}

@keyframes dotty {
  0% {
    content: "";
  }

  25% {
    content: ".";
  }

  50% {
    content: "..";
  }

  75% {
    content: "...";
  }

  100% {
    content: "";
  }
}
</style>
